export default function authHeader() {
  // Guard against localStorage access in non-browser environments (e.g., during build)
  if (typeof window === 'undefined' || typeof localStorage === 'undefined') {
    return {};
  }

  // @ts-ignore
  const user = JSON.parse(localStorage.getItem('user'));

  if (user && user.accessToken) {
    return { authorization: 'Bearer ' + user.accessToken };
  } else {
    return {};
  }
}
